import { useEffect, useState } from "react";
import SharedTable from "../../shared/sharedTable";
import ExportApi from "../../api/ExportApi";
import { formatToLocalDate } from '../../helper/utils';
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const TrackingLogs = () => {

    const [visitLogs, setVisitLogs] = useState([]);
    const [pagination, setPagination] = useState({});
    const [page, setPage] = useState(1);
     const [loader, setLoader] = useState(false);

    const columns = [
        {
            name: "Date",
            render: (row) => {
                return (
                    <div style={{ minWidth: "100px" }}> {formatToLocalDate(row?.createdAt)}</div>
                )
            }
        },
        {
            name: "User Email",
            render: (row) => {
                return (
                    <div>{row.userId?.email || "-"}</div>
                )
            }
        },
        {
            name: "Affiliate Code",
            render: (row) => row.affiliateId?.code || "-"
        },
        {
            name: "Affiliate Owner",
            render: (row) => row.affiliateId?.name || "-"
        },
        {
            name: "IP Address",
            render: (row) => row.userInfo?.ipAddress || "-"
        },
        {
            name: "Device Type",
            render: (row) => row.userInfo?.deviceType || "-"
        },
        {
            name: "Location",
            render: (row) =>
                [row.userInfo?.location?.city,
                row.userInfo?.location?.region,
                row.userInfo?.location?.country]
                    .filter(Boolean)
                    .join(", ") || "-"
        },
        {
            name: "Visited URL",
            render: (row) => {
                return (
                    <div>{row.visitedURL || "-"}</div>
                )
            }
        },
    ];

    const getUserVisitLogs = (pageParam) => {
        setLoader(true);
        ExportApi.getUserVisitLog({ pageParam })
            .then((resp) => {
                let data = resp.data;
                if (data?.success) {
                     setLoader(false);
                    setVisitLogs(data?.data);
                    setPagination(data?.pagination);
                }
                else {
                    setLoader(false);
                    setVisitLogs(data?.data);
                    toast.error(data?.message || "Error fetching affiliates");
                }
            })
            .catch((err) => {
                setLoader(false);
                console.log(err);
                toast.error("Error fetching affiliates");
            });
    }

    useEffect(() => {
        getUserVisitLogs(page);
    }, [page]);

    const downloadCSV = async () => {
        try {
            const resp = await ExportApi.downloadCSVForTrackingLogs({
                responseType: "blob"
            });

            const blob = new Blob([resp.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "user-visit-logs.csv");
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (err) {
            console.error(err);
            toast.error("Error downloading CSV");
        }
    };

    const handlePageClick = (event, value) => {
        setPage(value);
    };

    return (
        <div className="py-4">
            <div style={{ cursor: "pointer" }} className="d-flex justify-content-end align-items-end pb-2">
                <Button onClick={downloadCSV} style={{ backgroundColor: "black", color: "#fff" }} variant="primary" type="submit" className="">
                    Download CSV
                </Button>
            </div>

            <SharedTable loader={loader} columns={columns} data={visitLogs?.records || []} />

            {
                pagination?.totalPages > 1 && (
                    <Stack spacing={2}>
                        <Pagination
                            className="order_pagination"
                            count={pagination?.totalPages || 0}
                            color="primary"
                            hidePrevButton
                            hideNextButton
                            page={pagination?.page}
                            onChange={handlePageClick}
                        />
                    </Stack>
                )
            }

        </div>
    )
}

export default TrackingLogs;